import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { bem } from '../../core/design/bem';

const css = bem('GroupQuotaHeader');
const translationPrefix = 'group-visits';

type GroupQuotaHeaderProps = {
  /** Nombre de groupes déjà créés par l'utilisateur */
  groupCount: number;
  /** Nombre maximum de groupes autorisés (config `groupQuota`) */
  quota: number;
};

const GroupQuotaHeader = ({ groupCount, quota }: GroupQuotaHeaderProps): JSX.Element => {
  const { t } = useTranslation();
  const percent = quota > 0 ? Math.min(100, Math.round((groupCount / quota) * 100)) : 0;
  const isFull = groupCount >= quota;

  return (
    <div className={cx(css({ full: isFull }).toString())}>
      <div className={css('text').toString()}>
        <span className={css('count').toString()}>
          {groupCount} / {quota}
        </span>
        <span className={css('label').toString()}>{t(`${translationPrefix}.quota.label`)}</span>
      </div>
      <div className={css('bar').toString()}>
        <div className={css('fill').toString()} style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
};

export default GroupQuotaHeader;
